<div class="tab-pane" role="tabpanel" id="loteoconst">
    <fieldset id="agregar_loteoconst" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <div class="form-horizontal">
                        <form [formGroup]="form">
                            <div class="form-group" style="padding-top: 20px">
                                <label for="const_simultanea" class="col-md-3" align="left" >Loteo con construcci&oacute;n simultanea</label>
                                <div>
                                    <mat-radio-group formControlName="const_simultanea" (change)="add_loteo_const()">
                                        <mat-radio-button style="padding-right: 20px" name="const_simultanea" value="SI">SI</mat-radio-button>
                                        <mat-radio-button style="padding-right: 20px" name="const_simultanea" value="NO">NO</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </fieldset>
</div>
<div class="separator"></div>